import styled from "styled-components";
import CoverImg from "../../styles/assets/img/cover_img.png";
import { InputNum } from "../register/Register.style";
import { inputBox } from "../register/UserRegisterInfo";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showAlert } from "src/components/containers/Alert";
import { AdminAuth } from "src/common/auth/socialAuth";
import { useMutation } from "@tanstack/react-query";
import { request } from "src/common/api";
import { BaseResponse } from "src/common/types/baseRespones";
import {
  writeAccessToken,
  writeRefreshToken,
} from "src/common/functions/authFunctions";
import { useSetRecoilState } from "recoil";
import { userState } from "src/common/states/loginUser";

const AdmingContainer = styled.div`
  display: grid;
  width: 100vw;
  height: 100vh;
  grid-template-columns: 60% 40%;
`;

const Left = styled.div`
  background: url(${CoverImg}) right center / cover no-repeat;
`;

const Title = styled.div`
  position: absolute;
  display: flex;
  left: 80px;
  top: 100px;
  color: rgb(255, 255, 255);
  font-size: 4rem;
  font-weight: 800;
  flex-direction: column;
  gap: 14px;

  span {
    font-size: 1.8rem;
    font-weight: 300;
    line-height: 140%;
  }
`;

const BottonTitle = styled.div`
  position: absolute;
  display: flex;
  left: 0;
  bottom: 0;
  padding: 0px 80px 60px;
  color: rgb(255, 255, 255);
  font-size: 1.4rem;
  align-items: flex-end;
  justify-content: center;
  gap: 20px;
`;

const Right = styled.div`
  display: flex;
  padding: 0px 60px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 60px;
`;

const LoginTitle = styled.div`
  display: flex;
  font-size: 2.6rem;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 30px;

  span {
    color: rgba(0, 0, 0, 0.5);
    font-size: 1.6rem;
    font-weight: 400;
  }
`;
export const AdminMainPage = () => {
  const navi = useNavigate();
  const [userId, setUserId] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const setUser = useSetRecoilState(userState);

  const isAllFilled = !!userId && !!password;

  const adminLogin = useMutation({
    mutationFn: (loginDto: any) =>
      request<BaseResponse>({
        method: "POST",
        url: `/auth/login`,
        data: loginDto,
      }),
    onSuccess: async (res: any) => {
      if (res.response.accessToken) writeAccessToken(res.response.accessToken);
      if (res.response.refreshToken)
        writeRefreshToken(res.response.refreshToken);
      if (res.response.user) setUser(res.response.user);

      navi("/admin/users");
    },
  });

  const handleAdminLogin = (userInfo: any) => {
    try {
      AdminAuth.login(() => adminLogin.mutate(userInfo));
    } catch (error) {
      console.error("어드민 로그인 오류:", error);
      // 오류 처리
      showAlert("어드민 로그인 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  const data = isAllFilled
    ? [
        {
          userId,
          password,
        },
      ]
    : [];

  const handleSave = (userInfo: any) => {
    handleAdminLogin(userInfo);
  };

  return (
    <>
      <AdmingContainer>
        <Left>
          <Title>
            <span>실천이 쌓이고 습관이 되는 루틴 케어</span>관리자 페이지
          </Title>
          <BottonTitle>
            <b>참여기관</b>| <span>(주)인시스템</span>
          </BottonTitle>
        </Left>
        <Right>
          <LoginTitle>
            관리자 로그인<span>관리자 아이디 및 비밀번호를 입력해 주세요.</span>
          </LoginTitle>
          {/* 로그인 버튼들 */}
          <div
            className="Frame427319054"
            style={{
              width: "380px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              display: "inline-flex",
            }}
          >
            {/* 아이디 */}
            <div
              style={{
                //   display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  marginBottom: "4px",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    color: "#404040",
                    lineHeight: "24px",
                  }}
                >
                  아이디
                </span>
                <span
                  style={{
                    width: 6,
                    height: 6,
                    background: "#F57C00",
                    borderRadius: "50%",
                  }}
                />
              </label>
              <div
                style={{
                  ...inputBox,
                  width: "100%",
                  height: 48,
                  padding: "0 16px",
                }}
              >
                <InputNum
                  type="text"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="아이디를 입력해주세요"
                />
              </div>
            </div>

            {/* 비밀번호 */}
            <div
              style={{
                //   display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  marginBottom: "4px",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    color: "#404040",
                    lineHeight: "24px",
                  }}
                >
                  비밀번호
                </span>
                <span
                  style={{
                    width: 6,
                    height: 6,
                    background: "#F57C00",
                    borderRadius: "50%",
                  }}
                />
              </label>
              <div
                style={{
                  ...inputBox,
                  width: "100%",
                  height: 48,
                  padding: "0 16px",
                }}
              >
                <InputNum
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="비밀번호를 입력해주세요"
                />
              </div>
            </div>

            {/* 로그인 버튼 */}
            <button
              onClick={() => {
                if (isAllFilled) {
                  handleSave(data[0]);
                } else {
                  showAlert("아이디 또는 비밀번호를 입력해주세요");
                }
              }}
              className="IdLogin"
              style={{
                width: "100%",
                height: "48px",
                alignSelf: "stretch",
                padding: "8px 20px",
                background: isAllFilled ? "#F57C00" : "#fbd5af",
                borderRadius: 8,
                justifyContent: "center",
                alignItems: "center",
                gap: 12,
                display: "inline-flex",
                border: "none",
                cursor: "pointer",
                marginTop: 12,
              }}
            >
              <div
                className="ButtonText"
                style={{
                  width: "116px",
                  color: "white",
                  fontSize: 16,
                  fontFamily: "Pretendard",
                  fontWeight: "500",
                  wordWrap: "break-word",
                }}
              >
                로그인
              </div>
            </button>
          </div>
        </Right>
      </AdmingContainer>
    </>
  );
};
